<template>
  <div>
    <a-table :bordered="false" :dataSource="dataSource" :columns="columns" :pagination="false">
      <template slot="name" slot-scope="text, record">
        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
      </template>
      <template slot="operation" slot-scope="text, record">
        <a
          @click="() => editChild(record)"
        >修改</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          v-if="dataSource.length"
          title="确定删除这条吗"
          @confirm="() => onDelete(record.key,record.id)"
        >
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <a-button type="dashed" :disabled="showable" style="width: 100%" @click="$refs.recordAdd.edit(null, 'add')">
      <a-icon type="plus" /> 添加回款记录
    </a-button>
    <record-add
      @changeData="changeData"
      @editData="editData"
      ref="recordAdd"
    />
  </div>
</template>

<script>
import recordAdd from './recordAdd'
import moment from 'moment'
import { Ellipsis } from '@/components'
export default {
  name: 'RecordList',
  components: {
    recordAdd,
    Ellipsis
  },
  data () {
    return {
      count: 0,
      showable: false,
      dataSource: [],
      deleteList: [],
      columns: [
        {
          title: '日期',
          dataIndex: 'recordDate',
          width: '150px',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        },
        {
          title: '总金额',
          width: '300px',
          dataIndex: 'amount'
        },
        {
          title: '备注内容',
          dataIndex: 'remark',
          width: '600px',
          customRender: (text) => {
            return (
              <ellipsis length={100} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '150px',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  methods: {
    uploadData () {
      const toParentSource = {
        dataSource: this.dataSource,
        deleteList: this.deleteList }
      this.$emit('getData', toParentSource)
    },
    loadData (data, type) {
      this.dataSource = data
      data.forEach(da => {
        da.key = this.count
        this.count = this.count + 1
      })
      if (type === 'show') {
        this.showable = true
      } else {
        this.showable = false
      }
    },
    onCellChange (key, dataIndex, value) {
      const dataSource = [...this.dataSource]
      const target = dataSource.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
      }
    },
    changeData (value) {
      const { count, dataSource } = this
      const newData = value
      newData.key = count
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    },
    editData (value) {
      const newData = value
      const dataSource = [...this.dataSource]
      const index = this.dataSource.filter(item => item.key === value.key).map(data => data.key)
      this.dataSource = dataSource.filter(item => item.key !== value.key)
      this.dataSource.splice(index, 0, newData)
    },
    editChild (record) {
      this.$refs.recordAdd.edit(record, 'edit')
    },
    onDelete (key, id) {
      const dataSource = [...this.dataSource]
      const deleteList = [...this.deleteList]
      if (typeof (id) !== 'undefined' && id != null) {
        for (let i = 0; i < dataSource.length; i++) {
          if (dataSource[i].id === id) {
            deleteList.push(this.dataSource[i].id)
          }
        }
        this.dataSource = dataSource.filter(item => item.id !== id)
      }
      if (typeof (key) !== 'undefined' && key != null) {
        this.dataSource = dataSource.filter(item => item.key !== key)
      }
      this.deleteList = deleteList
    }
  }
}
</script>

<style scoped>

</style>
